import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Dots from "react-activity/lib/Dots";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  saveManufacturer,
  getManufacturersByAlpha,
  deleteManufacturer,
  getManufacturer,
} from "../../services/manufacturerService";
import { getCurrentUser } from "../../services/authService";
import ManufacturerForm from "./manufacturerForm";
import ManufacturersTable from "./manufacturersTable";
import AlphabetNavBar from "../common/alphabetNavBar";

class Manufacturers extends Component {
  state = {
    data: {
      manufacturer_id: 0,
      manufacturer_name: "",
      manufacturer_fullname: "",
      country_of_origin: "",
      related_brands_logos: "",
      website: "",
      kitmolds: "",
      years_active: "",
      owner_id: 0,
    },
    manufacturers: [],
    selectedAlpha: "1",
    loaded: true,
  };

  async componentDidMount() {
    this.setState({ loaded: false });

    const default_manufacturer = await this.getList("1");

    const user = getCurrentUser();

    const items = this.props.location.pathname.split("/");
    const manufacturer_id = items[3];

    if (items[2] === "add") {
      this.setState({ user, loaded: true });
      return;
    }

    let manufacturer;
    if (manufacturer_id === undefined) manufacturer = default_manufacturer;
    else {
      manufacturer = await getManufacturer(manufacturer_id);
    }
    this.setState({ data: manufacturer, user, loaded: true });
  }

  async getList(alpha) {
    const manufacturers = await getManufacturersByAlpha(alpha);

    this.setState({ selectedAlpha: alpha, manufacturers });

    return manufacturers[0];
  }

  handleInputChange = (input) => {
    const { data } = this.state;
    data[input.name] = input.value;

    this.setState({ data });
  };

  handleAlphabetChange = async (char) => {
    await this.getList(char);

    this.setState({ selectedAlpha: char });
  };

  handleEditManufacturer = (manufacturer) => {
    this.setState({ data: manufacturer });
    window.scrollTo(0, 0);
  };

  handleDeleteManufacturer = async (manufacturer) => {
    await deleteManufacturer(manufacturer.manufacturer_id);
    await this.getList(this.state.selectedAlpha);
    const data = this.clearForm();
    this.setState({ data });
    toast.success("Brand deleted succesfully.");
  };

  handleClearForm = () => {
    const data = this.clearForm();
    this.setState({ data });
  };

  clearForm() {
    let newdata = {};
    newdata.manufacturer_id = 0;
    newdata.manufacturer_name = "";
    newdata.manufacturer_fullname = "";
    newdata.country_of_origin = "";
    newdata.related_brands_logos = "";
    newdata.website = "";
    newdata.kitmolds = "";
    newdata.years_active = "";
    newdata.owner_id = 0;
    return newdata;
  }

  handleShowResults = () => {
    this.props.history.push("/manufacturer/results");
  };

  handleShowDetail = (manufacturer_id) => {
    if (manufacturer_id > 0)
      this.props.history.push(`/manufacturer/details/${manufacturer_id}`);
  };

  handleFormSubmit = async () => {
    const { data, user } = this.state;

    const manufacturer = {};
    Object.assign(manufacturer, data);
    if (manufacturer.owner_id === 0) manufacturer.owner_id = user.id;

    await saveManufacturer(manufacturer);

    this.clearForm();
    await this.getList(this.state.selectedAlpha);
    toast.success("Brand saved successfully!");
  };

  render() {
    const { data, manufacturers, user, selectedAlpha, loaded } = this.state;

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div
          style={{
            border: "1px solid darkgray",
            padding: "15px",
            marginBottom: "30px",
            borderRadius: "5px",
          }}
        >
          <div className="row">
            <div className="col-6" style={{ backgroundColor: "white" }}>
              {user && (
                <h5>
                  <FontAwesomeIcon icon="tools" />
                  &nbsp;Brands
                </h5>
              )}
            </div>
            <div className="col-6" style={{ textAlign: "right" }}>
              <table
                style={{
                  padding: "0px",
                  backgroundColor: "white",
                  width: "100%",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{ width: "60%", backgroundColor: "white" }}
                      align="right"
                    >
                      <Button
                        variant="link"
                        onClick={() =>
                          this.handleShowDetail(data.manufacturer_id)
                        }
                      >
                        <FontAwesomeIcon icon="image" />
                        &nbsp; Show Detail
                      </Button>
                    </td>
                    <td style={{ padding: "0px", backgroundColor: "white" }}>
                      <Button
                        variant="link"
                        onClick={() => this.handleShowResults()}
                      >
                        <FontAwesomeIcon icon="list" />
                        &nbsp; Search Results
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            {user && (
              <ManufacturerForm
                onInputChange={this.handleInputChange}
                onFormSubmit={this.handleFormSubmit}
                onClearForm={this.handleClearForm}
                data={data}
              />
            )}
          </div>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <AlphabetNavBar
            selectedAlpha={selectedAlpha}
            onCharChange={this.handleAlphabetChange}
          />
        </div>
        <div style={{ marginBottom: "100px" }}>
          <ManufacturersTable
            data={manufacturers}
            onEdit={this.handleEditManufacturer}
            onDelete={this.handleDeleteManufacturer}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Manufacturers);
